import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "rounded-xl w-1/2 relative overflow-hidden border text-blue-lp-500 border-blue-lp-500 bg-blue-lp-600" }
const _hoisted_2 = { class: "flex flex-row py-3 px-4 gap-1" }
const _hoisted_3 = { class: "w-1/2" }
const _hoisted_4 = { class: "text-xs" }
const _hoisted_5 = {
  key: 0,
  class: "font-bold mt-1 text-base"
}
const _hoisted_6 = { class: "font-normal text-base" }
const _hoisted_7 = {
  key: 1,
  class: "font-bold mt-1 text-base"
}
const _hoisted_8 = { class: "w-1/2" }
const _hoisted_9 = { class: "text-xs" }
const _hoisted_10 = {
  key: 0,
  class: "font-bold mt-1 text-base"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  width: "50",
  height: "50",
  viewBox: "0 0 38 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "absolute top-0 right-0"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "29.8691",
    cy: "8.86885",
    r: "22.0673",
    fill: "#1B48A0",
    "fill-opacity": "0.09"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "30.0635",
    cy: "9.0636",
    r: "30",
    fill: "#1B48A0",
    "fill-opacity": "0.08"
  })
], -1)
const _hoisted_12 = { class: "border border-gray-lp-200 py-3 px-4 rounded-xl w-1/2" }
const _hoisted_13 = { class: "text-gray-lp-600" }
const _hoisted_14 = {
  key: 0,
  class: "font-bold mt-1 text-xs"
}
const _hoisted_15 = { class: "text-gray-lp-300" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" • ")
const _hoisted_17 = { class: "text-gray-lp-600" }
const _hoisted_18 = {
  key: 1,
  class: "font-bold mt-1 text-xs"
}
const _hoisted_19 = { class: "border border-gray-lp-200 py-3 px-4 rounded-xl w-1/2" }
const _hoisted_20 = { class: "text-gray-lp-600" }
const _hoisted_21 = {
  key: 0,
  class: "font-bold mt-1 text-xs"
}
const _hoisted_22 = { class: "text-gray-lp-300" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" • ")
const _hoisted_24 = { class: "text-gray-lp-600" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" • ")
const _hoisted_26 = { class: "text-gray-lp-600" }
const _hoisted_27 = {
  key: 1,
  class: "font-bold mt-1 text-xs"
}
const _hoisted_28 = { class: "pb-4" }
const _hoisted_29 = { class: "p-4 flex justify-between items-center" }
const _hoisted_30 = { class: "flex items-center gap-2" }
const _hoisted_31 = {
  key: 0,
  class: "h-full justify-center py-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Search = _resolveComponent("Search")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.$t('dispatch.detail') + ' ' + _ctx.noDetailDispatch,
    "vertical-separator": false,
    fullPage: "",
    usePaddingVertical: false,
    customClass: "pr-0"
  }, {
    data: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 0,
            class: "my-4 py-3 px-4 flex gap-2 rounded-2xl"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Skeleton, {
                height: "2.5rem",
                width: "50%"
              }),
              _createVNode(_component_Skeleton, {
                height: "2.5rem",
                width: "50%"
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "my-4 py-3 px-4 flex gap-2 rounded-2xl"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("dispatch.totalSttKoli")), 1),
                    (!_ctx.isError)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.detailManifest.dispatchStts) + " STT ", 1),
                          _createVNode("span", _hoisted_6, "(" + _toDisplayString(_ctx.detailManifest.dispatchSttPieces) + " koli)", 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_7, " - "))
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("dispatch.totalBerat")), 1),
                    (!_ctx.isError)
                      ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.formatGrossWeight(_ctx.detailManifest.dispatchSttGrossWeights)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.detailManifest.dispatchToDriverId
                ? _ctx.$t("dispatch.courier")
                : _ctx.$t("dispatch.courierOrShuttle")), 1),
                (!_ctx.isError && (_ctx.detailManifest.dispatchToDriverId || _ctx.detailManifest.dispatchToShuttleId))
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.detailManifest.dispatchToDriverId ? 
                `${_ctx.detailManifest.dispatchToDriverId} - ${_ctx.detailManifest.dispatchToDriverName}` : 
                `${_ctx.detailManifest.dispatchToCityCode} - ${_ctx.detailManifest.dispatchToShuttleName}`), 1),
                      _hoisted_16,
                      _createVNode("span", _hoisted_17, _toDisplayString(_ctx.detailManifest.dispatchToDriverId ? 
                _ctx.detailManifest.dispatchToDriverPhone : 
                _ctx.detailManifest.dispatchToHubName), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_18, " - "))
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("dispatch.dispatchDate")), 1),
                (!_ctx.isError)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.formatDateFunc(
                  _ctx.detailManifest.dispatchCreatedAt.replace("+07:00", ""),
                  "DD MMMM YYYY, HH:mm"
                ) + " WIB"), 1),
                      _hoisted_23,
                      _createVNode("span", _hoisted_24, _toDisplayString(_ctx.limitLengthName(`${_ctx.detailManifest.dispatchCreatedByName}`)), 1),
                      _hoisted_25,
                      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.detailManifest.dispatchCreatedByRole), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_27, " - "))
              ])
            ]),
            _: 1
          })),
      _createVNode("div", _hoisted_28, [
        _createVNode(_component_Card, { class: "rounded-2xl pb-2" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_29, [
              _createVNode(_component_Search, {
                onInput: _ctx.onSearch,
                onClear: _ctx.clearSearch,
                value: _ctx.searchValue,
                class: "w-64",
                placeholder: _ctx.$t('dispatch.searchSttDem'),
                minChar: 1
              }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
              _createVNode("div", _hoisted_30, [
                _createVNode(_component_LpButton, {
                  title: _ctx.$t('dispatch.printManifest'),
                  textColor: "white",
                  id: "button_print_manifest",
                  onClick: _ctx._onPrintDispatchManifest,
                  iconLeft: "printer-white",
                  disabled: _ctx.isError,
                  fontWeight: "semibold"
                }, null, 8, ["title", "onClick", "disabled"]),
                _createVNode(_component_LpButton, {
                  title: _ctx.$t('dispatch.downloadData'),
                  textColor: _ctx.isError ? 'gray-lp-100' : 'red-lp-100',
                  customClass: 
                  _ctx.isError
                    ? 'bg-white border border-gray-lp-600'
                    : 'border border-red-lp-100'
                ,
                  id: "button_download_data",
                  onClick: _ctx._onDownloadData,
                  iconLeft: _ctx.isError ? 'download-new-gray' : 'download-new',
                  sizeIcon: "13.5px",
                  disabled: _ctx.isError,
                  flat: true,
                  fontWeight: "semibold"
                }, null, 8, ["title", "textColor", "customClass", "onClick", "iconLeft", "disabled"])
              ])
            ]),
            (_ctx.isError)
              ? (_openBlock(), _createBlock("div", _hoisted_31, [
                  _createVNode(_component_EmptyList, {
                    "button-action": _ctx.buttonActionError,
                    onAction: _ctx.getDetail,
                    icon: _ctx.errorData.image,
                    customHeaderMessage: _ctx.errorData.title,
                    customMessage: _ctx.errorData.message,
                    customClassImage: "w-44"
                  }, null, 8, ["button-action", "onAction", "icon", "customHeaderMessage", "customMessage"])
                ]))
              : (_openBlock(), _createBlock(_component_TableV2, {
                  key: 1,
                  firstRowHeader: _ctx.firstRowHeaderColumns,
                  loading: _ctx.isLoading,
                  columns: _ctx.columns,
                  data: _ctx.reportListData,
                  isEmpty: _ctx.isEmpty,
                  hidePagination: true,
                  isNoPaddingBottom: true,
                  borderTop: false,
                  borderBottom: false,
                  isDetailAble: false,
                  compactDesign: "",
                  bgHeader: "bg-white",
                  isBorderOnHeadBgWhite: "",
                  firstRowHeaderAlignment: "justify-start",
                  customColumnPaddingVertical: "pb-3",
                  headerTextColor: "text-sm"
                }, null, 8, ["firstRowHeader", "loading", "columns", "data", "isEmpty"]))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title"]))
}